<template>
  <div class="gp-has-header">
       <virtual-assistant type="user"/>
  </div>

</template>
<script>
  import VirtualAssistant from "../event/VirtualAssistant";

  export default {
    name: "user-assistant",
    order: 1,
    components: {
      VirtualAssistant
    },
    async mounted() {
      document.title = "Virtual Assistant"
    },
    methods: {

    }
  };

</script>

